// Galerie avec les vraies photos extraites du document Word
// 82 images organisées par domaine d'intervention

export const galleryWithRealPhotos = {
  batiment: {
    title: "Bâtiment",
    description: "Maçonnerie, Peinture, Toiture & Couverture, Descentes",
    images: [
      // Images de façades et réparations
      { id: 'bat1', url: '/images/realisations/image22.jpeg', title: 'Réparation de façade', subtitle: 'Maçonnerie' },
      { id: 'bat2', url: '/images/realisations/image23.jpeg', title: 'Ravalement de façade', subtitle: 'Travaux en hauteur' },
      { id: 'bat3', url: '/images/realisations/image24.jpeg', title: 'Intervention façade', subtitle: 'Réparations ponctuelles' },
      { id: 'bat4', url: '/images/realisations/image25.jpeg', title: 'Travaux de maçonnerie', subtitle: 'Restauration' },
      { id: 'bat5', url: '/images/realisations/image26.jpeg', title: 'Réfection de façade', subtitle: 'Maçonnerie' },
      { id: 'bat6', url: '/images/realisations/image28.jpeg', title: 'Cheminée', subtitle: 'Toiture' },
      { id: 'bat7', url: '/images/realisations/image29.jpeg', title: 'Travaux toiture', subtitle: 'Couverture' },
      { id: 'bat8', url: '/images/realisations/image30.jpeg', title: 'Intervention bâtiment', subtitle: 'Maçonnerie' },
      { id: 'bat9', url: '/images/realisations/image2.jpeg', title: 'Façade immeuble', subtitle: 'Ravalement' },
      { id: 'bat10', url: '/images/realisations/image35.jpeg', title: 'Réparation structure', subtitle: 'Bâtiment' },
      { id: 'bat11', url: '/images/realisations/image36.jpeg', title: 'Travaux façade', subtitle: 'Maçonnerie' },
      { id: 'bat12', url: '/images/realisations/image27.jpeg', title: 'Intervention toiture', subtitle: 'Couverture' },
    ]
  },
  
  ouvragesTechniques: {
    title: "Ouvrages Techniques",
    description: "Verrières, Garde-corps, Points d'ancrage, Structures",
    images: [
      { id: 'ot1', url: '/images/realisations/image40.jpeg', title: 'Installation structure', subtitle: 'Ouvrages métalliques' },
      { id: 'ot2', url: '/images/realisations/image41.jpeg', title: 'Montage technique', subtitle: 'Structures' },
      { id: 'ot3', url: '/images/realisations/image42.jpeg', title: 'Verrière', subtitle: 'Installation' },
      { id: 'ot4', url: '/images/realisations/image43.jpeg', title: 'Garde-corps', subtitle: 'Sécurisation' },
      { id: 'ot5', url: '/images/realisations/image48.jpeg', title: 'Structure métallique', subtitle: 'Ouvrages techniques' },
      { id: 'ot6', url: '/images/realisations/image53.jpeg', title: 'Installation technique', subtitle: 'Ouvrages' },
      { id: 'ot7', url: '/images/realisations/image54.jpeg', title: 'Bardage', subtitle: 'Façade' },
      { id: 'ot8', url: '/images/realisations/image55.jpeg', title: 'Travaux techniques', subtitle: 'Installation' },
    ]
  },
  
  evenementiel: {
    title: "Événementiel",
    description: "Bâches publicitaires, Enseignes lumineuses, Signalétique",
    images: [
      { id: 'ev1', url: '/images/realisations/image19.png', title: 'Bâche publicitaire', subtitle: 'Installation' },
      { id: 'ev2', url: '/images/realisations/image20.png', title: 'Signalétique', subtitle: 'Pose' },
      { id: 'ev3', url: '/images/realisations/image21.png', title: 'Enseigne', subtitle: 'Installation' },
      { id: 'ev4', url: '/images/realisations/image57.jpeg', title: 'Publicité en hauteur', subtitle: 'Événementiel' },
      { id: 'ev5', url: '/images/realisations/image58.jpeg', title: 'Bâche événementielle', subtitle: 'Pose' },
    ]
  },
  
  securite: {
    title: "Mise en Sécurité",
    description: "Filets anti-chute, Pics anti-volatiles, Protection, Sécurisation",
    images: [
      { id: 'sec1', url: '/images/realisations/image64.jpeg', title: 'Installation filet', subtitle: 'Sécurité' },
      { id: 'sec2', url: '/images/realisations/image67.jpeg', title: 'Filet anti-chute', subtitle: 'Protection' },
      { id: 'sec3', url: '/images/realisations/image68.jpeg', title: 'Sécurisation', subtitle: 'Filets' },
      { id: 'sec4', url: '/images/realisations/image71.jpeg', title: 'Pics anti-volatiles', subtitle: 'Installation' },
      { id: 'sec5', url: '/images/realisations/image73.jpeg', title: 'Protection chute', subtitle: 'Filet' },
      { id: 'sec6', url: '/images/realisations/image74.jpeg', title: 'Sécurité bâtiment', subtitle: 'Protection' },
      { id: 'sec7', url: '/images/realisations/image78.jpeg', title: 'Installation sécurité', subtitle: 'Filets' },
    ]
  },
  
  nettoyage: {
    title: "Nettoyage",
    description: "Vitres, Façades, Toitures, Démoussage, Haute pression",
    images: [
      { id: 'net1', url: '/images/realisations/image1.png', title: 'Nettoyage vitres', subtitle: 'Façade' },
      { id: 'net2', url: '/images/realisations/image19.png', title: 'Lavage façade', subtitle: 'Haute pression' },
      { id: 'net3', url: '/images/realisations/image20.png', title: 'Nettoyage immeuble', subtitle: 'Vitres' },
      { id: 'net4', url: '/images/realisations/image21.png', title: 'Entretien façade', subtitle: 'Nettoyage' },
    ]
  },
  
  maintenance: {
    title: "Entretien & Maintenance",
    description: "Contrats annuels, Inspections, Rapports, Diagnostics",
    images: [
      { id: 'main1', url: '/images/realisations/image80.jpeg', title: 'Inspection structure', subtitle: 'Maintenance' },
      { id: 'main2', url: '/images/realisations/image51.jpeg', title: 'Diagnostic bâtiment', subtitle: 'Entretien' },
      { id: 'main3', url: '/images/realisations/image52.jpeg', title: 'Contrôle périodique', subtitle: 'Inspection' },
    ]
  }
};

// Images de fond pour les sections (images plus grandes et panoramiques)
// Cache-busting pour forcer le rechargement des images optimisées
const cacheBuster = Date.now();
export const backgroundImages = {
  hero: '/images/realisations/image2.jpeg',
  about: `/images/paris1.jpg?v=${cacheBuster}`,
  services: '/images/paris3.jpg',
  gallery: '/images/paris4.jpg',
  contact: '/images/paris2.jpg'
};
